import { get, post } from '@/api/index';
export const searchquestion = params => get(`/api/paper/v1/searchquestion`, params); //试题搜索
